import firebase from "gatsby-plugin-firebase"
import { navigate } from "@reach/router"
import { store } from "../../store"
import { toast } from "react-toastify"
import { setUser, setPaid } from "../slices/authSlice"
import axios from "axios"

require("firebase/firestore")

var db = firebase.firestore()

class FirebaseAuth {
  getCurrentUserId() {
    return firebase.auth().currentUser.uid
  }
  loginWithGoogle = async () => {
    let provider = new firebase.auth.GoogleAuthProvider()
    let response = await firebase
      .auth()
      .signInWithPopup(provider)
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code
      })
    if (response) {
      navigate("/")
    }

    return
  }

  login = async (email, password) => {
    let response = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(function(error) {
        // Handle Errors here.
        if (error.code === "auth/user-not-found") {
          toast.error(`🕵️‍♂️ The user doesn't exist.`)
        }
        if (error.code === "auth/wrong-password") {
          toast.error(`🔑 The password is incorrect.`)
        }

        return
        // ...
      })
    return response
  }
  async logout() {
    await firebase
      .auth()
      .signOut()
      .catch(error => {})
    store.dispatch(setUser(false))
    store.dispatch(setPaid(false))
    return
  }

  async resetPassword(email) {
    return new Promise(resolve => {
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(() => {
          resolve(true)
        })
        .catch(error => {
          if (error.code === "auth/user-not-found") {
            toast.error(`🕵️‍♂️ The user doesn't exist.`)
          }
          resolve(false)
        })
    })
  }

  async register(email, password) {
    let response = await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .catch(error => {
        if (error.code === "auth/email-already-in-use") {
          toast.error("This e-mail is already associated with an account.")
        } else if (error.code === "auth/invalid-email") {
          toast.error("The e-mail address is invalid.")
        }
        return null
      })
    return response.user
  }

  initialiseUser() {
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        store.dispatch(setUser(true))
        store.dispatch(setPaid(await this.userPaid()))
      } else {
        store.dispatch(setUser(false))
      }
    })
  }

  userPaid = async () => {
    let loggedIn = store.getState().auth.user
    if (!loggedIn) return false
    try {
      let response = await axios.get(process.env.GATSBY_API_URL + "/has-paid", {
        headers: {
          Authorization: `Bearer ${await firebase
            .auth()
            .currentUser.getIdToken()}`,
        },
      })
      return response.data ? true : false
    } catch (err) {
      return false
    }
  }

  async getCurrectUserToken() {
    let currentUser = firebase.auth().currentUser
    let token = await currentUser.getIdToken()
    return token
  }
}

export default new FirebaseAuth()
